module.exports = __webpack_public_path__ + "static/media/img92.ae3026df.jpg";